module.exports = __webpack_public_path__ + "img/1585688880.6cbb021d.png";